import { render, staticRenderFns } from "./Ouvidoria.vue?vue&type=template&id=6ceb4cd7"
import script from "./Ouvidoria.vue?vue&type=script&lang=js"
export * from "./Ouvidoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports